module.exports = __webpack_public_path__ + "static/media/randomCardSFX.eaa852be.mp3";